import { StatusCode } from '@/constant';
import { http } from '../core';
import { URL } from "./_url";

const apiFetchNeighbourhoodsForPreview = async (communityCode: string) => {
  const response = await http.get(URL.PREVIEW_DATA(communityCode));
  if (response && response.status >= StatusCode.BADREQUEST) {
    throw new Error(response.status);
  }
  return response || null;
};

export { apiFetchNeighbourhoodsForPreview };
